import React, { useEffect } from "react";
import "./MobileSearch.scss";
import { useHistory } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "store/store";
import useToggle from "hooks/useToggle";
import Button from "components/Button/Button";
import searchicon from "assets/icons/search/search-icon.svg";
import LocationsDropdown from "../LocationsDropdown";
import CheckInDropDown from "../CheckInDropDown";
import AddGuestDropDown from "../AddGuestDropDown";
import CheckOutDropDown from "../CheckOutDropDown";
import { searchSelector, activeFilters} from "features/search-property/searchproperty.slice";
import { clearSearchResult } from "features/search-result/searchresult.slice";
import { useTranslation } from "react-i18next";

const MobileSearch: React.FC = () => {
	var tomorrow = new Date();
	const dispatch = useAppDispatch();
	const history = useHistory();
	const { t } = useTranslation();
	tomorrow.setDate(tomorrow.getDate() + 1);
	const { locations, checkin, guests, checkout, filters } = useAppSelector(searchSelector);
	const [showMobileSearch, toggleSearch] = useToggle();
	const locationChange = () => {
		let params: any = filters ? { ...filters } : {};
		if (Object.entries(params).length > 0) {

			// eslint-disable-next-line
			params = Object.entries(params).filter((item) => {
				if (item[0] === "longitude" || item[0] === "latitude" || item[0] === "from"
					|| item[0] === "to" || item[0] === "guests") { return item }
			})
				.reduce((accum: any, [k, v]) => {
					accum[k] = v;
					return accum;
				}, {});

		}
		const inputs: any = document.querySelector(".refine")?.getElementsByTagName('input');
		if (inputs) {
			for (let index = 0; index < inputs.length; ++index) {
				inputs[index].checked = false
			}

		}
		if (window.location.href.includes('search-result')) {
			params['latitude'] = locations.lat ?? null;
			params['longitude'] = locations.long ?? null;
			params['from'] = checkin.formattedD ?? null;
			params['to'] = checkout.formattedD ?? null;
			params['guests'] = guests.currentGuests.adult > 0 ? guests.currentGuests.adult : null;
			params['page'] = 1;
			params['location'] = locations.id ?? null;
			dispatch(clearSearchResult());
			toggleSearch();
			dispatch(activeFilters(params));
		}
		else {
			params['latitude'] = locations.lat ?? null;
			params['longitude'] = locations.long ?? null;
			params['from'] = checkin.formattedD ?? null;
			params['to'] = checkout.formattedD ?? null;
			params['guests'] = guests.currentGuests.adult > 0 ? guests.currentGuests.adult : null;
			params['page'] = 1;
			params['location'] = locations.id ?? null;
			dispatch(activeFilters(params));
			history.push("/search-results");
		}
	};
	useEffect(() => {
		const element1 = document.querySelector(".MobileSearch-content");
		if (showMobileSearch) {
			setTimeout(() => {
				element1?.classList.add("visible-o");
			}, 1000);
		} else {
			setTimeout(() => {
				element1?.classList.remove("visible-o");
			}, 1000);
		}
	}, [showMobileSearch]);
	return (
		<>
			<div>
				<div className="MobileSearch">
					<div className="MobileSearch-holder"
						onClick={() => {
							toggleSearch();
						}}>
						<div
							className="MobileSearch-location"
						>
							{locations.currentLocation ? locations.currentLocation :  `${t('search.title')}`}
						</div>
						<div
							className="MobileSearch-checkin"
							onClick={() => {
								toggleSearch();
							}}
							dir="ltr"
						>
							{checkin.currentFrom}
							{checkin.currentFrom && <span> - </span>} {checkout.currentTo}
							{/* Aug 3 - Aug 30 */}
							{guests.currentGuests.adult !== 0 && (
								<span className="MobileSearch-divider"> | </span>
							)}
						{guests.currentGuests.adult !== 0
								? guests.currentGuests.adult + " Guests"
								: ""}
						</div>
						<img
							alt="alt filler"
							src={searchicon}
							className={`MobileSearch-searchicon ${checkin.currentFrom || guests.currentGuests.adult !== 0
								? "MobileSearch-searchicon-active"
								: ""
								}`}
						></img>
					</div>
					<div
						className={`MobileSearch-content ${showMobileSearch ? "MobileSearch-content-show" : ""
							}`}
					>
						<LocationsDropdown></LocationsDropdown>
						<div className="MobileSearch-dates">
							<CheckInDropDown></CheckInDropDown>
							<CheckOutDropDown></CheckOutDropDown>
						</div>
						<AddGuestDropDown></AddGuestDropDown>
						<Button
							isPrimary={true}
							buttonText={t('search.title')}
							classes="MobileSearch-searchbtn"
							onClick={locationChange}
						></Button>
					</div>
				</div>
			</div>
		</>
	);
};

export default MobileSearch;
